export const CHART_SIZE = 258;
